var React = require('react');

function Callflow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 0a3 3 0 00-3 3v16a3 3 0 003 3h11a3 3 0 003-3v-2h4a2 2 0 012 2v17a4 4 0 004 4h4v5a3 3 0 003 3h11a3 3 0 003-3V34a3 3 0 00-3-3H34a3 3 0 00-3 3v4h-4a2 2 0 01-2-2V19a4 4 0 00-4-4h-4v-3h14v11a3 3 0 003 3h11a3 3 0 003-3V3a3 3 0 00-3-3H34a3 3 0 00-3 3v7H17V3a3 3 0 00-3-3H3zm30 38v7a1 1 0 001 1h11a1 1 0 001-1v-7H33zm13-2H33v-2a1 1 0 011-1h11a1 1 0 011 1v2zm0-33v2H33V3a1 1 0 011-1h11a1 1 0 011 1zm0 4H33v16a1 1 0 001 1h11a1 1 0 001-1V7zM15 5V3a1 1 0 00-1-1H3a1 1 0 00-1 1v2h13zM2 7h13v12a1 1 0 01-1 1H3a1 1 0 01-1-1V7z"}));
}

Callflow.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Callflow;

Callflow.default = Callflow;
